'use client';

import { useEffect } from 'react';
import { getWebAppUrl, isAppStoreUrl, shouldUseWebApp } from '@/lib/webApp';

/**
 * On mobile web, sends every Play Store / App Store link to the web app instead.
 *
 * One delegated listener rather than per-link changes, because store links are
 * hardcoded across many components. It listens in the bubble phase on document
 * so React onClick handlers (GA install events) still fire first; the default
 * navigation hasn't happened yet at that point, so it can still be cancelled.
 */
const StoreLinkRedirect = () => {
  useEffect(() => {
    if (!shouldUseWebApp(navigator.userAgent)) return;

    const handleClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0) return;
      const anchor = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!anchor || !isAppStoreUrl(anchor.href)) return;

      e.preventDefault();
      window.location.assign(getWebAppUrl(window.location.host));
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
};

export default StoreLinkRedirect;
